const { HTMLElementExt } = await import(
    window._resolveImport?.("html-element-ext") || "html-element-ext"
);

const { initialize } = await import(
    window._resolveImport?.("deferred") || "deferred"
);

class FetcherComponent extends HTMLElementExt {
    constructor() {
        super();
        this.deferredName = "fetcher";
        this.useCache = true;
        this.handlePopstate = this.onPopstate.bind(this);
        this.handles = {
            click: this.onClick.bind(this),
        };
    }

    connectedCallback() {
        super.connectedCallback();
        window.addEventListener("popstate", this.handlePopstate);
        // afterLoadCallback assigned to element in `global.js`
        // when script load triggered by popstate event
        this.afterLoadCallback?.();
    }

    onClick(event) {
        const link = event.target.closest("a[href]");

        if (link?.href) {
            event.preventDefault();
            this.loadContent(link.href);
        }
    }

    onPopstate(event) {
        const pushToHistory = false;

        if (this.id === event.state?.id && event.state.url)
            this.loadContent(event.state.url, pushToHistory);

        if (!event.state?.url)
            this.loadContent(window.location.href, pushToHistory);
    }

    loadContent(
        url,
        pushToHistory = true,
        onSuccess = () => {
            const section = this.dataset.section;

            publish(PUB_SUB_EVENTS.fetcherUpdate, { section });
        }
    ) {
        const loaderTarget = document.getElementById(this.dataset.loaderTarget);
        const update = () => {
            fetchSectionHTML(this.dataset.section, this.useCache, url)
                .then((html) =>
                    new DOMParser().parseFromString(html, "text/html")
                )
                .then((parsed) => {
                    parsed
                        .querySelectorAll('[data-updatable="true"]')
                        .forEach((updated) => {
                            const tagret = document.getElementById(updated.id);

                            if (tagret) {
                                tagret.innerHTML = updated.innerHTML;
                                initialize();
                                tagret.dispatchEvent(
                                    new CustomEvent("html-update", {
                                        bubbles: true,
                                    })
                                );
                            }
                        });
                    this.hideOverlay();

                    if (pushToHistory)
                        history.pushState(
                            {
                                deferredName: this.deferredName,
                                id: this.id,
                                url,
                            },
                            "",
                            url
                        );

                    onSuccess?.();
                });
        };

        loaderTarget && this.scrollIntoViewIfNeeded(loaderTarget);
        this.showOverlay();
        update();
    }

    getOverlay() {
        const loaderTarget = document.getElementById(this.dataset.loaderTarget);

        // try to find existing overlay
        let overlay = loaderTarget?.querySelector?.(".loading-overlay");

        if (!overlay && loaderTarget) {
            // overlay still not found; insert it
            let html = document.getElementById(
                "template__loading-overlay"
            )?.innerHTML;

            loaderTarget.insertAdjacentHTML?.("beforeend", html);
            overlay = loaderTarget.children[loaderTarget.children.length - 1];
        }

        return overlay;
    }

    hideOverlay() {
        const overlay = this.getOverlay();

        if (overlay) {
            overlay.classList.add("hidden");

            // overlay successfully hidden
            return true;
        }

        return false; // overlay not found
    }

    showOverlay() {
        const overlay = this.getOverlay();

        if (overlay) {
            overlay.classList.remove("hidden");

            // overlay successfully shown
            return true;
        }

        return false; // overlay not found
    }

    async scrollIntoViewIfNeeded(element) {
        const top = element.getBoundingClientRect().top;
        const headerOffset =
            document.querySelector("sticky-header")?.clientHeight || 0;

        if (top - headerOffset < 20) {
            let { getGlobalOffsetTop } = await import(
                window._resolveImport?.("helper") || "helper"
            );

            window.scroll({
                top: getGlobalOffsetTop(element) - headerOffset - 20,
                behavior: "smooth",
            });
        }
    }

    disconnectedCallback() {
        super.disconnectedCallback();
        window.removeEventListener("popstate", this.handlePopstate);
    }
}

export { FetcherComponent };
